import React from "react";
import GetPatients from "./GetPatients";

import Header from "./Header";
export default function Display() {
  document.title = "Show Patients";
  return (
    <div>
      <Header />
      <GetPatients />
    </div>
  );
}
